"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryType = exports.ValidationError = exports.GEOMETRY_COLLECTION = exports.FEATURE_TYPE = exports.FEATURE_COLLECTION_TYPE = void 0;
exports.FEATURE_COLLECTION_TYPE = 'FeatureCollection';
exports.FEATURE_TYPE = 'Feature';
exports.GEOMETRY_COLLECTION = 'GeometryCollection';
exports.ValidationError = {
    EMTPY: 'EMTPY',
    EMPTY_FEATURES: 'EMPTY_FEATURES',
    EMPTY_COORDINATES: 'INVALID_COORDINATES',
    EMPTY_TYPE: 'EMPTY_TYPE',
    INVALID_TYPE: 'INVALID_TYPE',
    INVALID_FEATURES: 'INVALID_FEATURES',
    INVALID_COORDINATES: 'INVALID_COORDINATES',
    INVALID_PROPERTIES: 'INVALID_PROPERTIES',
};
exports.GeometryType = {
    POINT: 'Point',
    MULTI_POINT: 'MultiPoint',
    LINE_STRING: 'LineString',
    MULTI_LINE_STRING: 'MultiLineString',
    POLYGON: 'Polygon',
    MULTI_POLYGON: 'MultiPolygon',
};
//# sourceMappingURL=types.js.map